// users/events/_statistics_form: sums of the female and male runners over all races
import $ from 'jquery';

$(() => {
  const femaleSum = document.getElementById('female_sum');
  const maleSum = document.getElementById('male_sum');
  if (!femaleSum || !maleSum) {
    return;
  }

  const female = Array.from(document.getElementsByClassName('female_runners'));
  const male = Array.from(document.getElementsByClassName('male_runners'));
  const sum = (inputs) => inputs.reduce((total, input) => total + (parseInt(input.value, 10) || 0), 0);
  const update = () => {
    femaleSum.textContent = sum(female);
    maleSum.textContent = sum(male);
  };

  update();
  female.concat(male).forEach((input) => input.addEventListener('input', update));
});
